// NHS Subscription Widget Tweaks
// 1. Rename "Subscribe" to "Subscribe & Save"
// 2. Change Add to Cart button text when subscription is active
// 3. Hide "Auto-renews" text entirely (CSS + JS fallback)

(function () {
  // Skip if new NHS purchase options component is present
  if (document.querySelector('nhs-purchase-options')) return;

  function findAndRename() {
    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    var node;
    while ((node = walker.nextNode())) {
      var text = node.textContent.trim();
      if (text === 'Subscribe') {
        node.textContent = node.textContent.replace('Subscribe', 'Subscribe & Save');
      }
    }
  }

  function toggleAutoRenewText() {
    // No-op — removed toggle logic, auto-renew text always visible
  }

  function updateButton() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;

    var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    var isSub = sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value !== '';

    var btnText = isSub ? 'ADD SUBSCRIPTION TO CART' : 'ADD TO CART';
    var span = btn.querySelector('span');
    var target = span || btn;
    if (target.textContent.trim() !== btnText) {
      target.textContent = btnText;
    }
  }

  function forceOneTimePurchase() {
    // Clear any pre-selected selling plan
    var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value !== '') {
      sellingPlanInput.value = '';
      sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Uncheck any subscription toggles
    var toggles = document.querySelectorAll('selling-plan-widget input[type="checkbox"]:checked');
    toggles.forEach(function (t) {
      t.click();
    });
  }

  function init() {
    findAndRename();
    forceOneTimePurchase();
    updateButton();
    toggleAutoRenewText();

    document.addEventListener('change', function (e) {
      // If a variant changed (not a subscription toggle), force one-time purchase
      var isVariantChange = e.target.closest('variant-selects') || e.target.closest('.nhs-pill-group') || (e.target.name && e.target.name.indexOf('selling_plan') === -1 && e.target.type === 'radio');
      if (isVariantChange) {
        setTimeout(forceOneTimePurchase, 100);
        setTimeout(forceOneTimePurchase, 300);
        setTimeout(forceOneTimePurchase, 600);
      }
      setTimeout(updateButton, 150);
      setTimeout(updateButton, 350);
      setTimeout(updateButton, 650);
      setTimeout(toggleAutoRenewText, 200);
      setTimeout(toggleAutoRenewText, 400);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('selling-plan-widget') || e.target.closest('.shopify-app-block')) {
        setTimeout(updateButton, 200);
        setTimeout(findAndRename, 200);
        setTimeout(toggleAutoRenewText, 250);
        setTimeout(toggleAutoRenewText, 500);
      }
    });
  }

  setTimeout(init, 1000);
  setTimeout(function () {
    forceOneTimePurchase();
    findAndRename();
    updateButton();
    toggleAutoRenewText();
  }, 2000);
  setTimeout(findAndRename, 3500);
})();
